module.exports = __webpack_public_path__ + "img/robot1.a62fed5a.png";